import { Flex, Image, ImageProps } from '@chakra-ui/react';
import * as React from 'react';
import { CDN_IMAGES_URL, commonConfig } from '../../../config';

export type MobileAppButtonsProps = ImageProps;

const MobileAppButtons = (props: MobileAppButtonsProps): React.ReactElement | null => {
  return (
    <Flex align="center" gap={4}>
      <a
        href={commonConfig.links.apps.appleApp}
        target="_blank"
        rel="noopener noreferrer"
        className="simple"
      >
        <Image
          src={`${CDN_IMAGES_URL}/apple-store.png`}
          alt="Apple store"
          htmlWidth="157"
          htmlHeight="52"
          maxW="none"
          w="auto"
          {...props}
          h={props.h || { base: '40px', sm: '50px' }}
        />
      </a>
      <a
        href={commonConfig.links.apps.googlePlay}
        target="_blank"
        rel="noopener noreferrer"
        className="simple"
      >
        <Image
          src={`${CDN_IMAGES_URL}/google-play.png`}
          alt="Google play"
          htmlWidth="176"
          htmlHeight="52"
          maxW="none"
          w="auto"
          {...props}
          h={props.h || { base: '40px', sm: '50px' }}
        />
      </a>
    </Flex>
  );
};
export default MobileAppButtons;
